import { createSelector } from 'reselect';
import { LOCALIZATIONS, PRODUCT_LECTURA, LANGUAGES } from 'root/lib/constants';

const getQuestWorkflow = state => state.questWorkflowReducer;

const getAppSession = state => state.appSessionReducer;

export const getProduct = createSelector([getAppSession], ({ product }) => product);

export const getLanguage = createSelector(
  [getQuestWorkflow, getProduct],
  ({ language }, product) => {
    if (product === PRODUCT_LECTURA) {
      return LANGUAGES.ES;
    }
    return language;
  },
);

export const getLocalization = createSelector(
  [getLanguage, getProduct],
  (language, product) => {
    if (product === PRODUCT_LECTURA) {
      return LOCALIZATIONS.SPA_ES_DEFAULT;
    }
    return LOCALIZATIONS[language.toUpperCase()];
  },
);
